export const vehicleListUrl = 'vehicle/vehicle_list/';
export const vehicleBrandsUrl = 'vehicle/brands/';
export const vehicleFleetsUrl = 'vehicle/fleets/';
export const updateVehicleColorUrl = 'vehicle/set_vehicle_color/';
export const vehicleBehaviourScoreUrl = 'vehicle/driver_behaviour_score/';
export const vehicleBehaviourScoreRealtimeUrl = 'vehicle/driver_behaviour_score_realtime/';
export const vehicleTripReportUrl = 'vehicle/trip_report/';
export const providerCredentialsUrl = 'connections/credentials/';
